import { emptyApi } from "./emptyApi";

export const HUMAN_SUPPORT_STATUS = {
  PENDING: "PENDING",
  ACTIVE: "ACTIVE",
  RESOLVED: "RESOLVED",
} as const;

export type HumanSupportEscalation = {
  uuid: string;
  status: (typeof HUMAN_SUPPORT_STATUS)[keyof typeof HUMAN_SUPPORT_STATUS];
  assigned_to: string | null;
  created_at: string;
} | null;

export const chatHumanSupportApi = emptyApi.injectEndpoints({
  endpoints: (build) => ({
    getHumanSupportStatus: build.query<
      HumanSupportEscalation,
      { groupId: string; channelId: string }
    >({
      query: ({ groupId, channelId }) => ({
        url: `/api/inkle/messaging/group/${groupId}/channel/${channelId}/human-support/`,
      }),
      providesTags: ["HUMAN_SUPPORT"],
    }),

    requestHumanSupport: build.mutation<
      HumanSupportEscalation,
      { groupId: string; channelId: string }
    >({
      query: ({ groupId, channelId }) => ({
        url: `/api/inkle/messaging/group/${groupId}/channel/${channelId}/human-support/`,
        method: "POST",
      }),
      invalidatesTags: ["HUMAN_SUPPORT"],
    }),

    withdrawHumanSupport: build.mutation<
      HumanSupportEscalation,
      { groupId: string; channelId: string }
    >({
      query: ({ groupId, channelId }) => ({
        url: `/api/inkle/messaging/group/${groupId}/channel/${channelId}/human-support/withdraw/`,
        method: "POST",
      }),
      invalidatesTags: ["HUMAN_SUPPORT"],
    }),

    joinHumanSupport: build.mutation<
      HumanSupportEscalation,
      { channelId: string }
    >({
      query: ({ channelId }) => ({
        url: `/api/inkle/messaging/channel/${channelId}/human-support/join/`,
        method: "POST",
      }),
      invalidatesTags: ["HUMAN_SUPPORT"],
    }),

    resolveHumanSupport: build.mutation<
      HumanSupportEscalation,
      { channelId: string }
    >({
      query: ({ channelId }) => ({
        url: `/api/inkle/messaging/channel/${channelId}/human-support/resolve/`,
        method: "POST",
      }),
      invalidatesTags: ["HUMAN_SUPPORT"],
    }),
  }),

  overrideExisting: false,
});

export const {
  useGetHumanSupportStatusQuery,
  useRequestHumanSupportMutation,
  useWithdrawHumanSupportMutation,
  useJoinHumanSupportMutation,
  useResolveHumanSupportMutation,
} = chatHumanSupportApi;
